import { QuestId } from './questId'

export enum KPKStage {
  Battery,
  Main,
  Win,
  Dispetcher,
  LowBattery,
  Bonus,
  BonusWin,
  End,
}

export enum CameraCabinetStage {
  Main,
  Win,
  BonusWin,
  End,
}
export enum OscilloscopeStage {
  StartDialog,
  Main,
  Win,
  End,
}

export enum BooksStage {
  Main,
  Win,
  Bonus,
  BonusWin,
  End,
}

export enum FlowersStage {
  Main,
  Win,
  End,
}

export enum KnotStage {
  Main,
  Win,
  End,
}

export enum ConstellationStage {
  Main,
  Animation,
  Win,
  End,
}

export enum ColumnsStage {
  Main,
  Win,
  End,
}

export enum CipherStage {
  Main,
  Win,
  End,
}

export enum TreesStage {
  GroupA,
  GroupAWin,
  // GroupB,
  // GroupBWin,
  // GroupC,
  // GroupCWin,
  End,
}

export enum HotteiStage {
  Main,
  Win,
  End,
}

export enum EyeStage {
  Main,
  Win,
  End,
}

export enum NightsongStage {
  Main,
  Win,
  End,
}

export enum EyeGateStage {
  Main,
  Win,
  End,
}

export enum HoteyStage {
  Main,
  Win,
  End,
}

export enum CameraStage {
  Main,
  Win,
  BonusWin,
  End,
}

export enum TapTapStage {
  Main,
  End,
}

export enum ProloguePartStage {
  Main,
  Win,
  End,
}

export enum StringStage {
  Main,
  Win,
  End,
}

export enum AccessStage {
  Main,
  Win,
  End,
}

export enum NamelessStage {
  Main,
  Win,
  End,
}

export enum LockStage {
  Animation,
  Main,
  Win,
  End,
}

export enum RiddleStage {
  Main,
  Win,
  End,
}

export enum NumbersStage {
  StartDialog,
  Main,
  Win,
  End,
}

export enum DotsStage {
  Main,
  Animation,
  Win,
  End,
}

export enum PanelkaStage {
  Main,
  Win,
  Bonus,
  BonusWin,
  End,
  WinQuest,
}

export enum NextStage {
  Main,
  Win,
  End,
}

export enum MessageStage {
  Main,
  Win,
  End,
}

export enum ElementsStage {
  Main,
  Win,
  End,
}

export enum ExpansionStage {
  Main,
  Win,
  End,
}

export enum CountingStage {
  Main,
  Win,
  End,
}

export enum FragmentationStage {
  Main,
  Win,
  End,
}

export enum SwitchStage {
  Main,
  Win,
  End,
}

export enum ChangesStages {
  Main,
  Animation,
  Win,
  End,
}

export enum DiskStage {
  Main,
  Win,
  End,
}

export enum Oscilloscope02Stage {
  Main,
  Win,
  End,
}

export enum DualityStage {
  Gate,
  Main,
  Win,
  End,
}

export enum NotQuestStage {
  Lock,
  Main,
  Win,
  End,
}

export enum QuietudeStage {
  Main,
  Win,
  End,
}

export enum Oscilloscope03Stage {
  Main,
  Win,
  End,
}

export enum VolumeStage {
  Main,
  Win,
  End,
}

export enum MirrorStage {
  Main,
  Win,
  End,
}

export enum ShadowStage {
  Main,
  Win,
  End,
}

export enum ChainStage {
  Main,
  Win,
  End,
}

export enum BoxStage {
  Lock,
  Main,
  Bonus,
  BonusWin,
  Win,
  End,
}

export enum VoidStage {
  Main,
  Win,
  End,
}

export enum DecryptStage {
  Main,
  Win,
  End,
}

export enum CurveStage {
  Main,
  Win,
  End,
}

export enum LightsStage {
  Main,
  Win,
  End,
}

export enum GapStage {
  Main,
  Win,
  End,
}

export enum CasseteStage {
  Main,
  Win,
  End,
}

export enum MomentStage {
  Lock,
  Main,
  Win,
  End,
}

export enum GridStage {
  Main,
  Win,
  End,
}

export enum OrderStage {
  Main,
  Win,
  End,
}

export enum PlaybackStage {
  Main,
  Win,
  End,
}

export enum AssemblyStage {
  Main,
  Win,
  End,
}

export enum WhisperStage {
  Main,
  Win,
  End,
}

export enum HollowStage {
  Main,
  Win,
  End,
}

export enum ResolveStage {
  Main,
  Win,
  End,
}

export enum RingStage {
  Main,
  Win,
  End
}

export enum SealStage {
  Main,
  Win,
  End
}

export enum ErrorStage {
  Main,
  Win,
  End
}

export enum CallStage {
  Main,
  Win,
  End
}

const KNOT_STAGES = [[KnotStage.Main, KnotStage.Win], [KnotStage.End]]

export const stagesByQuestId: Record<QuestId, number[][]> = {
  [QuestId.Nameless]: [
    [NamelessStage.Main, NamelessStage.Win],
    [NamelessStage.End],
  ],
  [QuestId.Access]: [[AccessStage.Main, AccessStage.Win], [AccessStage.End]],
  [QuestId.String]: [[StringStage.Main, StringStage.Win], [StringStage.End]],
  [QuestId.Hotey]: [[HoteyStage.Main, HoteyStage.Win], [HoteyStage.End]],
  [QuestId.Split]: [
    [ProloguePartStage.Main, ProloguePartStage.Win],
    [ProloguePartStage.End],
  ],
  [QuestId.Not]: [
    [ProloguePartStage.Main, ProloguePartStage.Win],
    [ProloguePartStage.End],
  ],
  [QuestId.Rhomb]: [
    [ProloguePartStage.Main, ProloguePartStage.Win],
    [ProloguePartStage.End],
  ],
  [QuestId.Spiral]: [
    [ProloguePartStage.Main, ProloguePartStage.Win],
    [ProloguePartStage.End],
  ],
  [QuestId.KPK]: [
    [KPKStage.Battery, KPKStage.Main, KPKStage.Win],
    [
      KPKStage.Dispetcher,
      KPKStage.LowBattery,
      KPKStage.Bonus,
      KPKStage.BonusWin,
    ],
    [KPKStage.End],
  ],
  [QuestId.Oscilloscope]: [
    [
      OscilloscopeStage.StartDialog,
      OscilloscopeStage.Main,
      OscilloscopeStage.Win,
    ],
    [OscilloscopeStage.End],
  ],
  [QuestId.Books]: [
    [BooksStage.Main, BooksStage.Win],
    [BooksStage.Bonus, BooksStage.BonusWin],
    [BooksStage.End],
  ],
  [QuestId.Flowers]: [
    [FlowersStage.Main, FlowersStage.Win],
    [FlowersStage.End],
  ],
  [QuestId.Guardians]: KNOT_STAGES,
  [QuestId.KnotKsarat]: KNOT_STAGES,
  [QuestId.KnotAsterion]: KNOT_STAGES,
  [QuestId.Constellation]: [
    [
      ConstellationStage.Main,
      ConstellationStage.Animation,
      ConstellationStage.Win,
    ],
    [ConstellationStage.End],
  ],
  [QuestId.Columns]: [
    [ColumnsStage.Main, ColumnsStage.Win],
    [ColumnsStage.End],
  ],
  [QuestId.Cipher]: [[CipherStage.Main, CipherStage.Win], [CipherStage.End]],
  [QuestId.Trees]: [
    [TreesStage.GroupA, TreesStage.GroupAWin],
    // [TreesStage.GroupB, TreesStage.GroupBWin],
    // [TreesStage.GroupC, TreesStage.GroupCWin],
    [TreesStage.End],
  ],
  [QuestId.Hottei]: [[HotteiStage.Main, HotteiStage.Win], [HotteiStage.End]],
  [QuestId.Nightsong]: [
    [NightsongStage.Main, NightsongStage.Win],
    [NightsongStage.End],
  ],
  [QuestId.EyeGate]: [
    [EyeGateStage.Main, EyeGateStage.Win],
    [EyeGateStage.End],
  ],
  [QuestId.Camera]: [
    [CameraStage.Main, CameraStage.Win],
    [CameraStage.BonusWin],
    [CameraStage.End],
  ],
  [QuestId.Eye]: [[EyeStage.Main, EyeStage.Win], [EyeStage.End]],
  [QuestId.TapTap]: [[TapTapStage.Main], [TapTapStage.End]],

  [QuestId.CameraCabinet]: [
    [CameraCabinetStage.Main, CameraCabinetStage.Win],
    [CameraCabinetStage.BonusWin],
    [CameraCabinetStage.End],
  ],
  [QuestId.Lock]: [
    [LockStage.Animation, LockStage.Main, LockStage.Win],
    [LockStage.End],
  ],
  [QuestId.Riddle]: [[RiddleStage.Main, RiddleStage.Win], [RiddleStage.End]],
  [QuestId.Numbers]: [
    [NumbersStage.StartDialog, NumbersStage.Main, NumbersStage.Win],
    [NumbersStage.End],
  ],
  [QuestId.Dots]: [
    [DotsStage.Main, DotsStage.Animation, DotsStage.Win],
    [DotsStage.End],
  ],
  [QuestId.CameraPanelka]: [
    [CameraCabinetStage.Main, CameraCabinetStage.Win],
    [CameraCabinetStage.BonusWin],
    [CameraCabinetStage.End],
  ],
  [QuestId.KnotVira]: KNOT_STAGES,
  [QuestId.Panelka]: [
    [PanelkaStage.Main, PanelkaStage.Win],
    [PanelkaStage.Bonus, PanelkaStage.BonusWin],
    [PanelkaStage.End],
  ],
  [QuestId.Next]: [[NextStage.Main, NextStage.Win], [NextStage.End]],
  [QuestId.Message]: [
    [MessageStage.Main, MessageStage.Win],
    [MessageStage.End],
  ],
  [QuestId.Elements]: [
    [ElementsStage.Main, ElementsStage.Win],
    [ElementsStage.End],
  ],
  [QuestId.KnotRuviy]: KNOT_STAGES,
  [QuestId.Expansion]: [
    [ExpansionStage.Main, ExpansionStage.Win],
    [ExpansionStage.End],
  ],
  [QuestId.Counting]: [
    [CountingStage.Main, CountingStage.Win],
    [CountingStage.End],
  ],
  [QuestId.Fragmentation]: [
    [FragmentationStage.Main, FragmentationStage.Win],
    [FragmentationStage.End],
  ],
  [QuestId.Switch]: [[SwitchStage.Main, SwitchStage.Win], [SwitchStage.End]],
  [QuestId.CameraOscilloscope]: [
    [CameraCabinetStage.Main, CameraCabinetStage.Win],
    [CameraCabinetStage.BonusWin],
    [CameraCabinetStage.End],
  ],
  [QuestId.Changes]: [
    [ChangesStages.Main, ChangesStages.Animation, ChangesStages.Win],
    [ChangesStages.End],
  ],
  [QuestId.KnotMorian]: KNOT_STAGES,
  [QuestId.Disk]: [[DiskStage.Main, DiskStage.Win], [DiskStage.End]],
  [QuestId.Oscilloscope02]: [
    [Oscilloscope02Stage.Main, Oscilloscope02Stage.Win],
    [Oscilloscope02Stage.End],
  ],
  [QuestId.Duality]: [
    [DualityStage.Gate, DualityStage.Main, DualityStage.Win],
    [DualityStage.End],
  ],
  [QuestId.KnotAilin]: KNOT_STAGES,
  [QuestId.Quietude]: [
    [QuietudeStage.Main, QuietudeStage.Win],
    [QuietudeStage.End],
  ],
  [QuestId.Oscilloscope03]: [
    [Oscilloscope03Stage.Main, Oscilloscope03Stage.Win],
    [Oscilloscope03Stage.End],
  ],
  [QuestId.Volume]: [[VolumeStage.Main, VolumeStage.Win], [VolumeStage.End]],
  [QuestId.NotQuest]: [
    [NotQuestStage.Lock, NotQuestStage.Main, NotQuestStage.Win],
    [NotQuestStage.End],
  ],
  [QuestId.Mirror]: [[MirrorStage.Main, MirrorStage.Win], [MirrorStage.End]],
  [QuestId.Shadow]: [[ShadowStage.Main, ShadowStage.Win], [ShadowStage.End]],
  [QuestId.Chain]: [[ChainStage.Main, ChainStage.Win], [ChainStage.End]],
  [QuestId.CameraMirror]: [
    [CameraCabinetStage.Main, CameraCabinetStage.Win],
    [CameraCabinetStage.BonusWin],
    [CameraCabinetStage.End],
  ],
  [QuestId.Box]: [
    [
      BoxStage.Lock,
      BoxStage.Main,
      BoxStage.Bonus,
      BoxStage.BonusWin,
      BoxStage.Win,
    ],
    [BoxStage.End],
  ],
  [QuestId.Void]: [[VoidStage.Main, VoidStage.Win], [VoidStage.End]],
  [QuestId.Decrypt]: [
    [DecryptStage.Main, DecryptStage.Win],
    [DecryptStage.End],
  ],
  [QuestId.KnotSafaris]: KNOT_STAGES,
  [QuestId.KnotFragments]: KNOT_STAGES,
  [QuestId.Curve]: [[CurveStage.Main, CurveStage.Win], [CurveStage.End]],
  [QuestId.Lights]: [[LightsStage.Main, LightsStage.Win], [LightsStage.End]],
  [QuestId.Gap]: [[GapStage.Main, GapStage.Win], [GapStage.End]],
  [QuestId.Cassete]: [
    [CasseteStage.Main, CasseteStage.Win],
    [CasseteStage.End],
  ],
  [QuestId.Moment]: [
    [MomentStage.Lock, MomentStage.Main, MomentStage.Win],
    [MomentStage.End],
  ],
  [QuestId.Grid]: [[GridStage.Main, GridStage.Win], [GridStage.End]],
  [QuestId.Order]: [[OrderStage.Main, OrderStage.Win], [OrderStage.End]],
  [QuestId.Playback]: [[PlaybackStage.Main, PlaybackStage.Win], [PlaybackStage.End]],
  [QuestId.Assembly]: [[AssemblyStage.Main, AssemblyStage.Win], [AssemblyStage.End]],
  [QuestId.Whisper]: [[WhisperStage.Main, WhisperStage.Win], [WhisperStage.End]],
  [QuestId.Hollow]: [[HollowStage.Main, HollowStage.Win], [HollowStage.End]],
  [QuestId.Resolve]: [[ResolveStage.Main, ResolveStage.Win], [ResolveStage.End]],
  [QuestId.Ring]: [[RingStage.Main, RingStage.Win], [RingStage.End]],
  [QuestId.Seal]: [[SealStage.Main, SealStage.Win], [SealStage.End]],
  [QuestId.Error]: [[ErrorStage.Main, ErrorStage.Win], [ErrorStage.End]],
  [QuestId.Call]: [[CallStage.Main, CallStage.Win], [CallStage.End]],
}
